import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Dep } from '../class/auth';
import { menulist } from '../class/status';
import { banktransfer_status } from '../../comm/class/status';
import { page } from '../../comm/class/status';
import * as moment from 'moment';

@Component({
    selector: 'app-banktransfer',
    templateUrl: './banktransfer.component.html',
    styleUrls: ['./banktransfer.component.css']
})

export class BanktransferComponent implements OnInit {
    time :any={};
    timeset = [{ type:1 , name: "今天", num: -0 },{ type:3 , name: "昨天", num: -1 },{ type:1 , name: "過去7天", num: -7 },{ type:1 , name: "過去30天", num: -30 }, ,{ type:2 , name: "上個月", num: -1 }, { type:2 , name: "上上個月", num: -2 }];
    link:string = environment.link;
    search_model:string = '';
    search_type:string='1';
    option_list:menulist = [{id:'1',name:'申請中'},{id:'2',name:'申請通過'},{id:'-2',name:'拒絕清單'}];
    data:any=[];
    edit_data:{ids:Array<number>,msg:string,status:number}={ids:[],msg:'',status:0};
    all_check:boolean;
    loading:boolean=false;
    preurl :string = '';
    money :string = '';
    urltoken :string = '';
    urltoken2 :string = '';
    banktransfer_status = banktransfer_status;
    pageobj:page = {page:0,count:100,total_count:0};
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj));
    showDatePickersTatusx = false;

    constructor(public httpClient: HttpClient,) {}

    ngOnInit(): void {
        this.preurl = environment.serverurl;
        this.init_list();
        this.urltoken = this.preurl+"/export_info.php?token="+Dep.token+"&time="+Date.now();
        this.urltoken2 = this.preurl+"/export_info_2.php?token="+Dep.token+"&time="+Date.now();
    }

    check_it(checked:boolean){
        this.data.forEach((value:any)=>{
            value.checked = checked
        })
    }

    handleRangeSelectedacc( value: any ): void {
        let  eventDate = value.event;
        this.time.startDate =  '';
        this.time.endDate =  '';
        if(eventDate.startDate){
            this.time.startDate =  moment(eventDate.startDate).format('YYYY-MM-DD')
            this.time.endDate =  moment(eventDate.endDate).format('YYYY-MM-DD')
        }
        this.showDatePickersTatusx = !this.showDatePickersTatusx;
        console.log(this.time,this.time.startDate,this.time.endDate);//都不存在 預設上是今天
        if (this.time.startDate.length > 0) { // 改變匯出的網址帶入參數
          this.urltoken = `${this.preurl}/export_info.php?token=${Dep.token}&time=${Date.now()}&startDate=${this.time.startDate}&endDate=${this.time.endDate}&searchType=${this.search_type}`;
          this.urltoken2 = `${this.preurl}/export_info_2.php?token=${Dep.token}&time=${Date.now()}&startDate=${this.time.startDate}&endDate=${this.time.endDate}&searchType=${this.search_type}`;
        }
        this.init_list();
    }

    init_list(){
        this.all_check = false;
        const body = {page: this.pageobj.page,count:this.pageobj.count,token:Dep.token,search:this.search_model,search_type:this.search_type,time:this.time,datestatus:this.showDatePickersTatusx};
        this.loading = true;
        this.httpClient.post<any>("/get_banktransfer_list.php",body).subscribe(res => {
            this.loading = false;
            this.money = res.money;
            if(res.status){
                this.data = res.data;
                this.pageobj.total_count = res.total_count
            }else{
                this.pageobj.total_count = 0
                this.data = [];
            }
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
        });
    }
    save(){
        const body = {data:this.edit_data};
        this.loading = true;
        this.httpClient.post<any>("/update_banktransfer.php",body).subscribe(res => {
        this.loading = false;
        this.init_list();
        console.log('save',res);
        });
    }

    edit(item:any){//個別編輯
        this.all_check = false;
        this.edit_data.ids = [item.id];
        this.edit_data.status = item.status;
        this.edit_data.msg = item.msg;
    }

    callback(pageobj:page){
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            this.init_list();
        }
    }

    success(){
        if(window.confirm("確定更改?")){
            this.patch(3);//已通過
            console.log(this.edit_data);
            this.save();//已通過
        }
    }

    patch(status:number){
        this.edit_data.ids = [];
        this.data.forEach((value:any)=>{
            if(value.checked||status==3){
                this.edit_data.ids.push(value.id);
            }
            this.edit_data.status = status;//預設是1
            this.edit_data.msg = '';//預設空字串
        })
    }
}
